import { render, staticRenderFns } from "./ClientAuditFlowDownOverview.vue?vue&type=template&id=4af4c470"
import script from "./ClientAuditFlowDownOverview.vue?vue&type=script&lang=js"
export * from "./ClientAuditFlowDownOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports